import { Injectable, input } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class DataService {
  
  orders: any[] = [];
  customer: any;

  loading: boolean = false; // debe partir en flase
  step = 1; // debe partir en 1
  errors = { input: '' }
  
  constructor() {}

  reset() {
    this.orders = [];
    this.customer = null;
    this.errors = { input: '' }
  }

}
